import { FC, useCallback, useState } from 'react'
import { useSwipeable } from 'react-swipeable'

import ContentCard, { ContentCardProps } from '../ContentCard'
import AccessibleHiddenText from '../AccessibleHiddenText'

import * as SC from './styled'

export type CardCarouselProps = {
  name?: string
  cards?: ContentCardProps[]
}

const CardCarousel: FC<CardCarouselProps> = (props) => {
  const { name, cards } = props
  const [currentSlideIdx, setCurrentSlideIdx] = useState<number>(0)
  const handlers = useSwipeable({
    onSwiped: (eventData) => {
      const { dir } = eventData
      switch (dir) {
        case 'Right':
          setCurrentSlideIdx((prev) => {
            if (prev - 1 >= 0) return prev - 1
            return prev
          })
          return
        case 'Left':
          setCurrentSlideIdx((prev) => {
            if (prev + 1 <= (cards?.length ?? 0) - 1) return prev + 1
            return prev
          })
          return
        default:
          return
      }
    },
    trackMouse: true,
  })

  const onDotHandler = useCallback(
    (idx) => {
      setCurrentSlideIdx(idx)
    },
    [setCurrentSlideIdx]
  )

  return (
    <SC.CardCarousel>
      <SC.Container aria-labelledby="carouselheading" {...handlers}>
        <AccessibleHiddenText id="carouselheading" text={name} />
        <SC.List currentSlideIdx={currentSlideIdx}>
          {cards?.map((c, index) => (
            <SC.CarouselItem key={c?.secondHighlightText} index={index}>
              <ContentCard {...c} />
            </SC.CarouselItem>
          ))}
        </SC.List>
      </SC.Container>
      <SC.Dots>
        {cards?.map((_c, index) => (
          <SC.Dot
            key={_c?.secondHighlightText}
            active={currentSlideIdx === index}
            onClick={() => onDotHandler(index)}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </SC.Dots>
    </SC.CardCarousel>
  )
}

export default CardCarousel
